import { useEffect, useState } from 'preact/hooks';
import { currentScreen, gameSetup } from '../../App';
import { sfx } from '../../lib/sfx';
import { translate } from '../../lib/i18n';
import type { Lang } from '../../lib/i18n';

interface HealthStatus {
  status: string;
  name: string;
  version: string;
  environment: string;
  timestamp: string;
}

export function StartScreen() {
  const [health, setHealth] = useState<HealthStatus | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [hasSaves, setHasSaves] = useState(false);
  const lang = (gameSetup.value.language ?? 'es') as Lang;
  const t = (k: Parameters<typeof translate>[0]) => translate(k, lang);

  useEffect(() => {
    fetch('/api/health')
      .then((r) => r.json())
      .then(setHealth)
      .catch(() => setError(t('connecting') === 'Connecting...' ? 'Backend unreachable' : 'Sin conexion'));

    fetch('/api/game/saves', { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => setHasSaves((data.saves ?? []).length > 0))
      .catch(() => {});
  }, []);

  return (
    <div class="center-screen">
      <div class="pixel-border container text-center">
        <h1 class="pixel-title text-yellow mb-3" style={{ fontSize: '28px' }}>
          M X L T I V E R S E
        </h1>
        <p class="text-dim mb-2">{t('tagline')}</p>

        <div class="mt-3" style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          {hasSaves && (
            <button class="pixel-btn text-yellow" onClick={() => { sfx.success(); currentScreen.value = 'saves'; }}>
              {t('continue')}
            </button>
          )}
          <button class="pixel-btn text-green" onClick={() => { sfx.success(); currentScreen.value = 'auth'; }}>
            {t('play')}
          </button>
        </div>

        <div class="mt-3 text-dim" style={{ fontSize: '14px' }}>
          {health && (
            <p>
              {t('backend_ok')}: <span class="text-green">{health.status}</span>
              {' | '}v{health.version}
              {' | '}{health.environment}
            </p>
          )}
          {error && <p class="text-red">{error}</p>}
          {!health && !error && <p>{t('connecting')}</p>}
        </div>
      </div>
    </div>
  );
}
